<!--
 * @Description: 
 * @Version: 1.0
 * @Autor: 胡彩丽 hucaili@qfei.cn
 * @LastEditors: 胡彩丽 hucaili@qfei.cn
-->
<template>
  <div :class="['field_list_item', `field_list_item${props.level}`]" :style="props.level ? { position: 'absolute', left: `${(props.level - 1) * 150}px`, top: `-${(props.level + 1) * 30}px` } : {}">
    <jw-input :placeholder="$t('搜索插入字段')" class="select_search_field" v-model="data.search_field" allow-clear @input="fieldInputSearch($event, index)" @blur="fieldSearch($event, index)" @clear="fieldSearch($event, index)">
      <template #suffix><icon-search /></template>
    </jw-input>
    <ul class="select_field select_field_ul">
      <li v-for="item in fieldOptions" @mouseover="onMouseEnter(item)" @mouseleave="onMouseLeave" class="select_field-li" :title="item.fieldName" @click="fieldSelect(item)" :key="item.fieldKey">
        <span class="field_name">{{ item.fieldName }}</span>
        <span v-if="item.fieldType == 12" class="right-icon"><icon-right /></span>
        <xl-field-cascade v-if="item?.records?.length > 0" :fieldList="item.records" :level="item.level" />
      </li>
    </ul>
  </div>
</template>
<script setup>
import { reactive, computed } from 'vue';
// import useViewFields from '@/hooks/view-fields';
// const { enableList, getViewFields } = useViewFields();
const props = defineProps({
  fieldList: {
    //字段数据
    type: Array,
    default: () => []
  },
  level: {
    type: [Number, String]
  }
});
const data = reactive({
  search_field: '', //搜索
  fieldList: [],
  originalFieldList: []
});
const fieldOptions = computed(() => props.fieldList);
//搜索字段
const fieldSearch = ($event, index) => {
  data.fieldList = searchFn($event.target?.value || '', index);
};
const fieldInputSearch = (value, index) => {
  data.fieldList = searchFn(value, index);
};
// 搜索更新数组
const searchFn = (keyword, index) => {
  // 先深拷贝原数组，防止直接修改原数据
  const copiedFieldList = [...data.originalFieldList];
  // 对指定索引位置的数组元素应用过滤
  if (index in copiedFieldList) {
    copiedFieldList[index] = copiedFieldList[index].filter((field) => field.fieldName.includes(keyword));
  }
  // 返回新的过滤后的数组
  return copiedFieldList;
};
// 选择字段
const fieldSelect = () => {};
// 获取字段
const getFieldsList = async () => {
  //   data.fieldList = [[
  //     { label: '线索', value: 'lead.association_HRCyYt', type: 0, name: '线索', id: 1 },
  //     { label: '分配次数', value: 'lead.countDistribute', type: 7, name: '分配次数', id: 2 },
  //     { label: '上次分配时间', value: 'lead.lastDistributeTime', type: 8, name: '上次分配时间', id: 3 },
  //     { label: '客户', value: 'lead.customerId', type: 12, name: '客户', id: 4,
  //     }
  //   ]];
};
const onMouseEnter = async (field, index) => {
  console.log(field, index);
  if (field.fieldType === 12) {
    // 获取新数据
    // await getViewFields({ id: field.fieldExt,apiIndex: `${field.fieldExt}-${Math.random() * 100}`  });
    // const updatedFieldList = [...data.fieldList];
    // updatedFieldList.splice(index+1, 1, enableList.value);
    // data.fieldList = updatedFieldList;
  }
};
const onMouseLeave = (field, index) => {
  console.log('移出', field, index);
  //   data.active_leave_index=index;
};
defineExpose({
  getFieldsList
});
</script>
<style scoped lang="less">
@import './xl-field-cascade.less';
</style>
